// @ts-strict-ignore
import omit from 'lodash/omit';

import {apiClient} from 'common/util/api-client';
import {getReportUrl} from 'common/report/util';
import type {DownloadReportRequest} from 'common/types/schema4api/webapp/reports/types';
import {getLocation} from 'common/util/url';

export async function makeDownloadQuery(projectId, workspaceId, params: DownloadReportRequest): Promise<Blob> {
  const useCache = !!params.report_cache;

  try {
    // using apiClient.fetch because we're getting back a blob
    // eslint-disable-next-line local-rules/deprecated-member-access
    const response = await apiClient.fetch(getReportUrl(`download/`, {projectId, workspaceId}), {
      headers: {
        'Request-URL': getLocation().href,
      },
      body: JSON.stringify(params),
      method: `POST`,
    });
    return await response.blob();
  } catch (err) {
    // if fetch returns 500 with cache try again without cache due to Django's RequestDataTooBig
    if (useCache) {
      return await makeDownloadQuery(projectId, workspaceId, omit(params, `report_cache`));
    } else {
      throw err;
    }
  }
}
